import { render } from "./ListLoader.vue?vue&type=template&id=3bd6149d"
import script from "./ListLoader.vue?vue&type=script&lang=js"
export * from "./ListLoader.vue?vue&type=script&lang=js"
script.render = render

export default script